/* Progressive enhancement: content is visible without JavaScript. */
(() => {
  const setup = (root) => {
    const els = [...root.querySelectorAll('.mr-reveal')];
    if (!els.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(el => el.classList.add('is-visible'));
      return;
    }
    root.classList.add('mr-guide--motion');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -20px 0px', threshold: 0.06 });
    els.forEach(el => observer.observe(el));
  };
  const init = () => document.querySelectorAll('.mr-guide').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.mr-guide').forEach(setup));
})();
